import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getFourteenDaysAgo() {
  const today = new Date()
  const sevenDaysAgo = new Date()

  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 14)

  const stringToday = getStringDateAndHourFromDate(today)
  const stringSevenDaysAgo = getStringDateAndHourFromDate(sevenDaysAgo)

  const options = {
    name: 'FOURTEEN_DAYS_AGO',
    label: '2 Semanas',
    startDate: stringSevenDaysAgo.date,
    finalDate: stringToday.date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
